/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
/* #__PURE__ */
import { ApiResultError } from './ApiError';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function toFormData(obj) {
    if (Array.isArray(obj)) {
        throw new Error('Expected object, got array');
    }
    else if (typeof obj === 'object' && obj != null) {
        return Object.entries(obj).reduce((acc, [key, value]) => {
            if (value instanceof Blob) {
                acc.append(key, value);
            }
            else if (Array.isArray(value) && value.every(x => x instanceof Blob)) {
                value.forEach((blob, idx) => {
                    acc.append(`${key}_${idx}`, blob);
                });
            }
            else if (typeof value === 'string') {
                acc.append(key, value);
            }
            else {
                acc.append(key, new Blob([JSON.stringify(value)], {
                    type: 'application/json',
                }));
            }
            return acc;
        }, new FormData());
    }
    throw new Error(`Expected object, got ${typeof obj}`);
}
/**
 * A base that assigns the data given in the constructor to the object, while being safe for
 * prototype pollution.
 */
export class AssigningBase {
    /**
     * Assign the data in source to `this`.
     *
     * @param source The data to store in `this`.
     */
    constructor(source) {
        for (const attr in source) {
            if (attr === '__proto__') {
                continue;
            }
            // @ts-expect-error Typescript doesn't understand our custom assign.
            this[attr] = source[attr];
        }
    }
}
/**
 * Filters the input to check if it is an instance of ``ApiResultError``.
 *
 * If it is, the error is thrown, otherwise the input data is returned.
 *
 * @param data The data to check, which could potentially be an error instance.
 * @returns The input data if it is not an ApiResultError.
 */
export function filterApiResultError(data) {
    if (data instanceof ApiResultError) {
        throw data;
    }
    return data;
}
/**
 * Creates a function that processes a Response object using a specified parser function,
 * and then constructs a result object using a provided configuration function.
 *
 * @param config Configuration object with methods and properties to handle the response.
 * @param parser Function to parse the response into a desired format.
 * @returns A function that takes a Response and returns a Promise resolving to an ApiResult.
 */
export function makeResult(config, parser) {
    return async (response) => {
        const parsed = await parser(response);
        return config.makeResult(response, parsed);
    };
}
/**
 * Creates a Headers object from a given object map of header key-value pairs.
 * Only non-null values are included in the final Headers object.
 *
 * @param obj Object containing the header key-value pairs.
 * @returns A new Headers object with the non-null values set.
 */
export function makeHeaders(obj) {
    const result = new Headers();
    for (const [key, value] of Object.entries(obj)) {
        if (value != null) {
            result.set(key, value);
        }
    }
    return result;
}
